import { Card } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Marcin K.",
      location: "Warszawa",
      rating: 5,
      text: "Mój Trek otrzymał mroczny makeover i teraz wygląda jak rower z przyszłości. Jakość wykonania to absolutny top level!",
      project: "Mroczny tuning MTB"
    },
    {
      name: "Anna W.",
      location: "Kraków", 
      rating: 5,
      text: "Neonowy tuning mojego roweru szosowego to najlepsza inwestycja! Teraz jestem widoczna z kilometra, a rower wygląda obłędnie.",
      project: "Neon Road Bike"
    },
    {
      name: "Tomasz M.",
      location: "Gdańsk",
      rating: 5,
      text: "Klasyczny tuning z subtelnymi zmianami - dokładnie to, czego szukałem. Profesjonalne podejście i terminowość na najwyższym poziomie.",
      project: "Klasyczny refresh"
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-muted/10 to-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-montserrat font-bold text-4xl md:text-5xl mb-6">
            Co mówią nasi <span className="text-gradient-primary">Klienci</span>
          </h2>
          <p className="text-xl text-muted-foreground font-inter">
            Zadowoleni kolarze to nasz najlepszy marketing
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="p-6 bg-card/50 backdrop-blur-sm border-accent/20 interactive-scale relative overflow-hidden">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-primary/20" />
              
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-warning text-warning" />
                ))}
              </div>

              <blockquote className="text-foreground font-inter mb-6 leading-relaxed">
                "{testimonial.text}"
              </blockquote>

              <div className="border-t border-accent/20 pt-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-montserrat font-semibold text-foreground">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-muted-foreground font-inter">
                      {testimonial.location}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-primary font-semibold font-inter">
                      {testimonial.project}
                    </p>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground font-inter mb-4">
            Dołącz do grona zadowolonych klientów
          </p>
          <span className="text-gradient-secondary font-montserrat font-bold text-lg">
            Twój rower czeka na transformację!
          </span>
        </div>
      </div>
    </section>
  );
};